import React, { useEffect } from 'react';
import { CheckCircle } from 'lucide-react';
import { Button } from './ui/button';

const FormularioConfirmacion = ({ onClose }) => {
  useEffect(() => {
    // Prevenir scroll del body cuando el modal está abierto
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-95 flex items-center justify-center z-50 p-4">
      <div className="max-w-md w-full text-center">
        {/* Logo animado - REMOVIDO para evitar desalineación */}

        {/* Ícono de éxito con animación */}
        <div className="mb-6 relative">
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-24 h-24 bg-green-500/20 rounded-full animate-ping"></div>
          </div>
          <div className="relative flex items-center justify-center">
            <div className="w-24 h-24 bg-green-500 rounded-full flex items-center justify-center">
              <CheckCircle className="w-16 h-16 text-white" strokeWidth={3} />
            </div>
          </div>
        </div>

        {/* Mensaje principal */}
        <h2 className="text-3xl font-bold text-white mb-4">
          ¡Solicitud Registrada con Éxito!
        </h2>

        {/* Mensaje secundario */}
        <div className="bg-slate-800/50 backdrop-blur-sm border border-gray-700 rounded-lg p-6 mb-8">
          <p className="text-lg text-gray-300 leading-relaxed">
            Tu solicitud ha sido registrada exitosamente. 
          </p>
          <p className="text-lg text-yellow-500 font-semibold mt-3">
            Recibirás un correo electrónico con las instrucciones para agendar tu cita.
          </p>
          <p className="text-sm text-gray-400 mt-4">
            Por favor revisa tu bandeja de entrada y la carpeta de spam.
          </p>
        </div>

        {/* Botón de cerrar */}
        <Button
          onClick={onClose}
          className="bg-yellow-500 hover:bg-yellow-400 text-black font-semibold text-lg px-8 py-6 w-full"
        >
          Cerrar Ventana
        </Button>

        {/* Texto adicional */}
        <p className="text-xs text-gray-500 mt-6">
          Si tienes alguna pregunta, contáctanos a través de nuestro correo de soporte.
        </p>
      </div>
    </div>
  );
};

export default FormularioConfirmacion;
